import { Component, Input } from '@angular/core'
import { IntakeModel, QuestionBase } from '@mmx/shared'
import { filter, find, isArray, isEmpty, isNil, startCase } from 'lodash'
import moment from 'moment'

@Component({
  selector: 'mmx-custom-question',
  templateUrl: './custom-question.component.html',
  styleUrls: ['./custom-question.component.scss'],
  standalone: false,
})
export class CustomQuestionComponent {
  @Input() intake: IntakeModel
  @Input() question: QuestionBase<any>
  @Input() value: any

  constructor() {}

  showIfQuestions(question: any) {
    const questionAnswer = find(
      this.intake.customQuestions,
      (q) => q.id === question.id,
    )

    if (
      question &&
      !isNil(question.if) &&
      question.if === questionAnswer.value
    ) {
      return true
    } else if (isNil(question.if) && questionAnswer.value) {
      return true
    }
    return false
  }

  isImageQuestion(question: QuestionBase<any>): boolean {
    // we need to handle File and Image questions (File = Patient selects a file, Image = Patient draws on an image)
    return (
      question &&
      (question.controlType === 'input-file-upload' ||
        question.controlType === 'canvas')
    )
  }

  isUnexpectedQuestion(question: QuestionBase<any>): boolean {
    // we need to handle File and Image questions (File = Patient selects a file, Image = Patient draws on an image)
    return (
      question.expectedAnswer != null &&
      this.getQuestionValue(question) !== question.expectedAnswer
    )
  }

  getQuestionValue(question: QuestionBase<any>) {
    const questionAnswer = find(
      this.intake.customQuestions,
      (q) => q.id === question.id,
    )
    let value
    if (questionAnswer) {
      value = questionAnswer.value
      if (typeof value !== 'undefined' && value != null) {
        switch (question.controlType) {
          case 'boolean':
            return value === true
              ? 'Yes'
              : value === false
                ? 'No'
                : '[No Answer]'

          case 'address':
            value = filter([
              value.address1 || '',
              value.address2 || '',
              value.address3 || '',
              (value.city
                ? value.state || value.zip
                  ? `${value.city}, `
                  : value.city
                : '') +
                (value.state
                  ? value.zip
                    ? `${value.state} `
                    : value.state
                  : '') +
                (value.zip || ''),
              value.country || '',
            ])
            return value.join(', \n ')

          case 'date':
            return moment(value).format('MM/DD/YYYY')

          case 'table':
            return value
          case 'bodySelector':
            return Object.keys(value)
              .filter((key) => value[key])
              .map(startCase)
              .join(', ')

          case 'checkbox':
            return value.join(', ')

          default:
            if (isArray(value)) {
              return value.join(', ')
            }

            return !isEmpty(value) ? value : '[No Answer]'
        }
      } else {
        switch (question.controlType) {
          case 'bodySelector':
            return Object.keys(value)
              .filter((key) => value[key])
              .map(startCase)
          default:
            return value
        }
      }
    }

    return value
  }
}
